import { create } from 'zustand'

/**
 * Global open-state for the counter-sale panel (spec/clubmanager/15 BR-17). A tiny
 * store so the topbar **＋ Venta** button and the ⌘K command-palette
 * action can both open the one shared `SalePanel` (create mode) from
 * anywhere — without prop-drilling through the shell. The panel itself
 * is mounted once in `app-shell`; this only carries the boolean.
 */
interface QuickSaleState {
  open: boolean
  openQuickSale: () => void
  closeQuickSale: () => void
}

export const useQuickSaleStore = create<QuickSaleState>((set) => ({
  open: false,
  openQuickSale: () => set({ open: true }),
  closeQuickSale: () => set({ open: false }),
}))
